import {createAsyncThunk} from "@reduxjs/toolkit";
import {AppDispatch, RootState} from "../store";
import {configurationApi} from "../../api/configurationApi";
import {AppDesign, UpdateAppDesignColor, UpdateAppDesignLogo} from "../../types/configurationType";
import {handleRequest} from "../utils/handleRequest";
import i18n from "../../i18n";

export const fetchAppDesignThunk = createAsyncThunk<
    Partial<AppDesign>,
    void,
    { dispatch: AppDispatch; state: RootState; rejectValue: string }
>(
    "configuration/appDesign",
    async (_, {dispatch, rejectWithValue}) => {
        const res = await handleRequest(
            dispatch,
            "indirect",
            () => configurationApi.getAppDesign()
        );
        if (!res.success()) {
            return rejectWithValue(res.errorMessage ?? "Failed to fetch app design");
        }
        return res.result as Partial<AppDesign>;
    }
);

export const updateAppDesignColorThunk = createAsyncThunk<
    Partial<AppDesign>,
    UpdateAppDesignColor,
    { dispatch: AppDispatch; state: RootState; rejectValue: string }
>(
    "configuration/appDesign/color",
    async (payload, {dispatch, rejectWithValue}) => {
        const res = await handleRequest(
            dispatch,
            "direct",
            () => configurationApi.updateAppDesignColor(payload),
            i18n.t("requestMessage.appDesignUpdated")
        );
        if (!res.success()) {
            return rejectWithValue(res.errorMessage ?? "Failed to update app design");
        }
        return res.result as Partial<AppDesign>;
    }
);

export const updateAppDesignLogoThunk = createAsyncThunk<
    Partial<AppDesign>,
    File | null,
    { dispatch: AppDispatch; state: RootState; rejectValue: string }
>(
    "configuration/appDesign/logo",
    async (file, {dispatch, rejectWithValue}) => {
        const res = await handleRequest(
            dispatch,
            "direct",
            () => configurationApi.updateAppDesignLogo(file),
            i18n.t("requestMessage.appDesignUpdated")
        );
        if (!res.success()) {
            return rejectWithValue(res.errorMessage ?? "Failed to update app design");
        }
        return res.result as Partial<AppDesign>;
    }
);